module.exports = __webpack_public_path__ + "img/transparent-disclosure-section-introduction.7d0363b6.svg";